module.exports = __webpack_public_path__ + "img/fly-img.7e3017ee.jpg";